import React, { useState, useEffect } from "react"
import { renderToString } from 'react-dom/server'
import {
  Box,
} from '@material-ui/core';

import SearchImage from "../../images/searchImage.svg"
import SmoothieImage from "../../images/smoothieImage.svg"

import { allQuestions, smoothieTypes } from "../../pages/Home.js"
import { DefaultContainer, TitleAndSubTitle, Stepper,} from "./Step1.js"

import "./AIThinking.css";
import AIThinking from "./AIThinking";

const Step7 = ({step, setStep, reps, setReps}) => {

  const [finalPercent, setFinalPercent] = useState(0)

  const entierAleatoire = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  useEffect(() => {
    let timing = entierAleatoire(20000, 25000)
    console.log(timing)
    //let startTiming = Date.now();
    let endTiming = Date.now() + timing;

    //on calcule les points
    let questions = [{qID : "q1", sID : "step1"}, {qID :  "q2", sID : "step2"}, {qID : "q3", sID : "step3"}]
    let smoothies = JSON.parse(JSON.stringify(smoothieTypes))
    smoothies.forEach((smoothie) => {
      smoothie.points = 0
    })
    questions.forEach((infos) => {
      let questions = allQuestions[infos.sID].questions
      let rep = reps[infos.qID]
      let pointFor = questions[rep]?.pointFor
      let findSmoothie = smoothies.find((el) => el.id === pointFor)
      if (findSmoothie) {
        findSmoothie.points += 1
      }
    })
    smoothies = smoothies.sort((a, b) => b.points - a.points);
    if (smoothies[0]?.points !== smoothies[1]?.points) {
      //on a un choix
      console.log("on a un choix", smoothies[0])
      setReps({...reps, smoothieChoiceID : smoothies[0]?.id})
    } else {
      //égalité, on prend le résultat de la Q1
      let questions = allQuestions["step1"].questions
      let rep = reps["q1"]
      let pointFor = questions[rep]?.pointFor
      let findSmoothie = smoothies.find((el) => el.id === pointFor)
      console.log("on a une égalité", findSmoothie)
      setReps({...reps, smoothieChoiceID : findSmoothie?.id})
    }

    const intervalId = setInterval(() => {  //assign interval to a variable to clear it.
      let actTime = Date.now();
      let diff = endTiming - actTime
      if (diff < 0) { diff = 0 }

      let percent = (diff*100/timing)
      let reversePercent = 100-percent
      //console.log(reversePercent)
      setFinalPercent(reversePercent)
    }, 20);

    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
      setFinalPercent(100)
      setStep(8)
    }, timing);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    }
  }, [])

  const findReps = (sID, qID) => {
    //allQuestions?.step1?.questions[reps?.q1]?.title
    let questions = allQuestions[sID]?.questions
    let rep = reps[qID]
    return questions[rep]?.forEnd
  }


  return (
    <>
      <DefaultContainer>
        {/*<Stepper step={step}/>*/}

        {/*<TitleAndSubTitle
          title={allQuestions?.step7?.title}
          subTitle={allQuestions?.step7?.subTitle}
        />*/}
        <Box sx={{
          display:"flex",
          flexDirection:"column",
          gap:"90px",
          paddingTop:"250px",
        }}>
          <Box sx={{
            fontSize:"70px",
            fontWeight:"600",
            color:"primary.main",
            textAlign:"center"
          }}>
            <AIThinking
              phrases={["Gemini analyse vos réponses...", "Infusion des insights stratégiques dans votre boisson...", "Ajout du lait...", "Gemini compose votre smoothie..."]}
              loop={false}
            />
          </Box>
        </Box>

        {/* CENTER */}
        <Box sx={{flex:1, marginTop:"240px", display:"flex", flexDirection:"column", alignItems:"center", paddingLeft:"105px", paddingRight:"105px"}}>
          <Box sx={{
            width:"100%",
            borderRadius:"24px",
            height:"310px",
            display:"flex",
            flexDirection:"row",
            gap:"20px",
            background: "rgba(255, 255, 255, 0.8)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            boxShadow: "0px 16px 32px rgba(59, 102, 245, 0.06)",
            padding:"20px",
          }}>
            <Box sx={{
              width:"80px",
              height:"80px",
              background:"url('./static/logo.png')",
              backgroundSize:"contain",
              animation: "rotate linear infinite 3s",
            }} />
            <Box>
              {/*<Box sx={{
                fontSize:"35px",
                fontWeight:"600",
                height:"75px",
                display:"flex",
                alignItems:"center"
              }}>
                Gemini compose votre smoothie en fonction de vos préférences
              </Box>*/}
              <Box sx={{
                fontSize:"33px",
                fontWeight:"500",
                fontStyle:"italic",
                color:"#94A3B8",
                paddingLeft:"10px",
                paddingTop:"10px"
              }}>
                Ton énergie : {findReps("step1", "q1")}<br/>
                Ton endroit : {findReps("step2", "q2")}<br/>
                Ta recherche : {findReps("step3", "q3")}<br/>
                Ton boost : {findReps("step4", "q4")}<br/>
                Ta base : {findReps("step5", "q5")}<br/>
                Ta crème : {findReps("step6", "q6")}<br/>
              </Box>
            </Box>
          </Box>

          <Box sx={{marginTop:"350px", position:"relative"}}>
            <Box>
              <img src={SearchImage} />
            </Box>
            <Box sx={{position:"absolute", top:0, left:0, width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center"}}>
              <img src={SmoothieImage} style={{animation: "jump-shaking 1s infinite",}}/>
            </Box>
          </Box>

          <Box sx={{marginTop:"140px"}}>
            <Box sx={{width:"1200px", height:"40px", background:"rgba(156, 163, 175, 0.27)", borderRadius:"100px", position:"relative"}}>
              <Box sx={{width:finalPercent+"%", height:"100%", background:"#4285F4", borderRadius:"100px", position:"absolute"}} />
            </Box>
            <Box sx={{fontSize:"65px", fontWeight:"500", textAlign:"center", marginTop:"50px"}}>
              {parseInt(finalPercent)} %
            </Box>
          </Box>
        </Box>

      </DefaultContainer>
    </>
  );
};

export default Step7;
